module.exports = __webpack_public_path__ + "static/media/Escudo-VII-Obispo-Diocesis-Guanare.736e54ce.jpg";